import { __decorate } from "tslib";
import Vue from 'vue';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Authentication = class Authentication extends VuexModule {
    constructor() {
        super(...arguments);
        this.accessToken = null;
        this.isAuthLoading = true;
    }
    get axiosHeader() {
        return {
            headers: {
                Authorization: `Bearer ${this.accessToken}`
            }
        };
    }
    get account() {
        return Vue.prototype.$msal.getAllAccounts()[0];
    }
    get isLoggedIn() {
        return this.accessToken ? this.accessToken.length > 0 : false;
    }
    async setAccessToken(accessToken) {
        return { accessToken };
    }
    async setIsAuthLoading(isAuthLoading) {
        return { isAuthLoading };
    }
    async fetchAccessToken() {
        const tokenRequest = { account: Vue.prototype.$msal.getAllAccounts()[0], scopes: Vue.prototype.$authConfig.scopes };
        let accessToken = null;
        try {
            var tokenResponse = await Vue.prototype.$msal.acquireTokenSilent(tokenRequest);
            accessToken = tokenResponse.accessToken;
        }
        catch (tokenError) {
            try {
                await Vue.prototype.$msal.acquireTokenRedirect(tokenRequest);
            }
            catch (tokenRedirectError) {
                console.error('Problem getting token with redirect flow: ' + tokenRedirectError);
            }
        }
        return { accessToken: accessToken || this.state.accessToken, isAuthLoading: false };
    }
};
__decorate([
    MutationAction({ mutate: ['accessToken'] })
], Authentication.prototype, "setAccessToken", null);
__decorate([
    MutationAction({ mutate: ['isAuthLoading'] })
], Authentication.prototype, "setIsAuthLoading", null);
__decorate([
    MutationAction({ mutate: ['accessToken', 'isAuthLoading'] })
], Authentication.prototype, "fetchAccessToken", null);
Authentication = __decorate([
    Module({ namespaced: true, name: 'authentication' })
], Authentication);
export default Authentication;
